module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chaptitle",
    attrs: {
      "id": "ch01"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "height": "140",
      "src": "images/ch01.jpg",
      "width": "450"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "monsterfonts-spookhouse"
  }, [_c('strong', [_vm._v("When suddenly. . .")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A massive bubble of gas erupted from the murky bottom of Putrescent Pond and oozed upward through the stinking pool of thick gray slime. The bubble pushed against the pond’s oily skin, which bulged into an enormous greasy dome.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three ragged gray creatures with swirly blue eyes stood on the shore and watched intently. They tilted their heads to one side, pointed their enormous schnozzles toward the dome, stamped their puny feet impatiently, and sniffed hungrily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Remember this. It’s important later.")]), _vm._v(" "), _c('p', {
    staticClass: "image-b"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('img', {
    attrs: {
      "alt": "Images",
      "height": "550",
      "src": "images/f0002-01.jpg",
      "width": "386"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1c385f8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 75
// module chunks = 0